export default {
    intro: '将打乱的句子按正确顺序排列吧！',
    indicator: ({ values }: { values: { isAllDone: boolean } }) => {
        const { isAllDone } = values;
        if (isAllDone) { return '请再次阅读完成的文章。'; }
        return '请将句子按正确顺序排列！';
    },
    table: { question: '题目', answerRate: '正确率', emptyMessage: '没有内容。' },
    roundNumber: '第{number}题',
};
